module.exports = __webpack_public_path__ + "static/media/img-thumbnail-sushi-01.f5c3b4cb.webp";